import { useState, useEffect } from "react";
import { ThreeDots } from "react-loader-spinner";
import { API_UPDATE_EMPLOYEE_ACCESS } from "../../config/Endpoints";
import { putApi } from "../../utils/api";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import CommonDatePicker from "../../components/CommonDatePicker";

const EMPLOYEE_STATUS_LABELS = {
  VERIFIED: "Working",
  BLOCKED: "Blocked",
  LEFTOUT: "Left Organization",
};

const EmployeeAccess = ({ userData }) => {
  const [isLoading, setIsLoading] = useState();
  const [status, setStatus] = useState("");
  const accessToken = Cookies.get("accessToken");
  const [managerId, setManagerId] = useState("");
  const [leftoutDate, setLeftoutDate] = useState("");

  const [designationId, setDesignationId] = useState("");
  const [reason, setReason] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const tabElement = document.getElementById("tab11-tab");

    const handleTabShown = () => {
      setStatus(userData?.status);
      setLeftoutDate("");
      setReason("");
      setManagerId("");
      setDesignationId("");
    };

    if (tabElement) {
      tabElement.addEventListener("shown.bs.tab", handleTabShown);
    }
    return () => {
      if (tabElement) {
        tabElement.removeEventListener("shown.bs.tab", handleTabShown);
      }
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (status !== "") {
        setIsLoading(true);

        const URL =
          status === "LEFTOUT"
            ? `${API_UPDATE_EMPLOYEE_ACCESS}?employeeId=${userData?.id}&status=${status}&leftOutReason=${reason}&leftOutDate=${leftoutDate}`
            : `${API_UPDATE_EMPLOYEE_ACCESS}?employeeId=${userData?.id}&status=${status}`;

        await putApi(URL, {}, accessToken)
          .then((res) => {
            if (res.status === 200) {
              setIsLoading(false);
              toast.success(res.data.message, {
                position: toast.POSITION.TOP_RIGHT,
              });
              navigate("/dashboard/employee-directory");
            }
          })
          .catch((e) => {
            setIsLoading(false);
            toast.error(e?.response?.data?.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            console.log(e);
          });
      } else {
        toast.error("Please select status field.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      toast.error(e?.response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });

      setIsLoading(false);
      console.log(error);
    }
  };

  const handleChangeStatus = (e) => {
    setStatus(e.target.value);
  };

  const handleInputChange = (event) => {
    const { value, type } = event.target;
    if (type === "date") {
      const year = value.split("-")[0];

      if (year.length <= 4) {
        setLeftoutDate(value);
      }
    } else {
      setLeftoutDate(value);
    }
  };

  // Get today's date in the format yyyy-mm-dd
  const today = new Date().toISOString().split("T")[0];
  // Function to convert "DD-MM-YYYY" to "YYYY-MM-DD"
  // const formatDate = (dateStr) => {
  //   const [day, month, year] = dateStr.split("-");
  //   return `${year}-${month}-${day}`;
  // };

  const formatDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "";
    const parts = dateStr.split("-");
    if (parts.length !== 3) return "";
    const [day, month, year] = parts;
    return `${year}-${month}-${day}`;
  };

  // Set the min date
  const minDate = userData ? formatDate(userData?.doj) : "";

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <div className="row mt-3">
            <div className="col-md-2"></div>
            <div className="col-md-3  d-flex align-items-center ">
              <label htmlFor="managerName">Current Status</label>
            </div>
            <div className="col-md-4 ">
              <input
                type="text"
                name="status"
                className="border disable ps-3"
                value={
                  EMPLOYEE_STATUS_LABELS[userData?.status] ||
                  userData?.status ||
                  "-"
                }
                readOnly
              />
            </div>
            <div className="col-md-2"></div>
          </div>
          {userData?.status !== "LEFTOUT" && (
            <div className="row mt-3">
              <div className="col-md-2"></div>
              <div className="col-md-3 d-flex align-items-center">
                <label htmlFor="status" className="has-asterisk">
                  Status
                </label>
              </div>
              <div className="col-md-4">
                <select
                  id="status"
                  className="border"
                  required
                  name="status"
                  value={status}
                  onChange={handleChangeStatus}
                >
                  <option value="">Select Status</option>
                  <option value="VERIFIED">Working</option>
                  <option value="BLOCKED">Blocked</option>
                  <option value="LEFTOUT">Left Organization</option>
                </select>
              </div>
              <div className="col-md-2"></div>
            </div>
          )}
          {status === "LEFTOUT" && userData?.status !== "LEFTOUT" && (
            <>
              <div className="row mt-3">
                <div className="col-md-2"></div>
                <div className="col-md-3  d-flex align-items-center">
                  <label htmlFor="status" className="has-asterisk">
                    Leftout Date
                  </label>
                </div>
                <div className="col-md-4">
                  <CommonDatePicker
                    minDate={minDate}
                    maxDate={today}
                    selectedDate={leftoutDate}
                    setSelectedDate={setLeftoutDate}
                  />
                  {/* <input
                    type="date"
                    required
                    name="dob"
                    className="border"
                    value={leftoutDate}
                    placeholder="MM-dd-yyyy"
                    onChange={handleInputChange}
                    max={today}
                    min={minDate}
                  /> */}
                </div>
                <div className="col-md-2"></div>
              </div>
              <div className="row mt-3">
                <div className="col-md-2"></div>
                <div className="col-md-3  d-flex align-items-center">
                  <label htmlFor="status" className="has-asterisk">
                    Leftout Reason
                  </label>
                </div>
                <div className="col-md-4">
                  <textarea
                    cols={15}
                    rows={5}
                    className="border"
                    maxLength={225}
                    required
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    name="comment"
                    minLength={5}
                    onKeyPress={(e) => {
                      // Prevent adding space at the beginning
                      if (e.charCode === 32 && e.target.selectionStart === 0) {
                        e.preventDefault();
                      }

                      // Regular expression to allow only letters, numbers, and spaces
                      const allowedCharsRegex = /^[a-zA-Z0-9 ]*$/;

                      // Check if the character is allowed
                      const char = String.fromCharCode(e.charCode);
                      if (!allowedCharsRegex.test(char)) {
                        e.preventDefault(); // Prevent non-alphanumeric character input
                      }
                    }}
                  ></textarea>
                </div>
                <div className="col-md-2"></div>
              </div>
            </>
          )}
        </div>
        {userData?.status !== "LEFTOUT" && (
          <div className="justify-content-center modal-footer">
            <button
              type="submit"
              disabled={isLoading || status === userData?.status}
              // onClick={handleSubmit}
              className={isLoading ? "theme-button disabled " : "theme-button "}
            >
              {isLoading ? (
                <ThreeDots
                  height="20"
                  width="53"
                  radius="9"
                  color="white"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              ) : (
                "Submit"
              )}
            </button>
            {/* <button
          type="button"
          className="theme-button bg-grey mx-3 w-35 cancel-promote"
          data-bs-dismiss="modal"
          //   onClick={handleClose}
        >
          Cancel
        </button> */}
          </div>
        )}
      </form>
    </>
  );
};

export default EmployeeAccess;
